export default __webpack_public_path__ + "static/media/MountainHuntingLodgeMap.148563fe.jpg";